"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getExtensionFromFileName(fileName) {
    if (!fileName) {
        return null;
    }
    var start = fileName.lastIndexOf('.');
    if (start > 0) {
        return fileName.substr(start).toLowerCase();
    }
    return null;
}
exports.default = getExtensionFromFileName;
function getExtensionWithoutDotFromFileName(fileName) {
    var extension = getExtensionFromFileName(fileName);
    return extension ? extension.replace('.', '') : null;
}
exports.getExtensionWithoutDotFromFileName = getExtensionWithoutDotFromFileName;
//# sourceMappingURL=getExtensionFromFileName.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-file-common/lib/utils/getExtensionFromFileName.js
// module id = 1567
// module chunks = 0 1 11 13 24 43 84 100 106 107